var Extensions;

module.exports = Extensions = (function() {
  Extensions.PRIORITY_NORMAL = 0;

  Extensions.PRIORITY_FIRST = -1;

  Extensions.PRIORITY_LAST = 1;

  function Extensions() {
    this.extensionPointsToExtensions = new Map;
  }

  Extensions.prototype.add = function(extensionPoint, extension, priority) {
    var extensions;
    if (priority == null) {
      priority = Extensions.PRIORITY_NORMAL;
    }
    extensions = this.extensionPointsToExtensions.get(extensionPoint);
    if (!extensions) {
      extensions = [];
      this.extensionPointsToExtensions.set(extensionPoint, extensions);
    }
    extensions.needsSort = true;
    return extensions.push({
      extension: extension,
      priority: priority
    });
  };

  Extensions.prototype.remove = function(extensionPoint, extension) {
    var ref, result;
    return result = (ref = this.extensionPointsToExtensions.get(extensionPoint)) != null ? ref.filter : void 0;
  };

  Extensions.prototype.processExtensions = function(extensionPoint, callback, returnFirst) {
    var each, extensions, i, len, result;
    extensions = this.extensionPointsToExtensions.get(extensionPoint);
    if (extensions) {
      if (extensions.needsSort) {
        extensions.sort(function(a, b) {
          return a.priority - b.priority;
        });
      }
      for (i = 0, len = extensions.length; i < len; i++) {
        each = extensions[i];
        result = callback(each);
        if (result !== void 0 && returnFirst) {
          return result;
        }
      }
    }
  };

  return Extensions;

})();



/*****************
 ** WEBPACK FOOTER
 ** ./lib/extensions.js
 ** module id = 209
 ** module chunks = 0
 **/